import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PayTillNowClient, PayTillNowParkingSessionInfoDTO, PayTillNowSessionDTO } from 'src/app/base/models/models.swagger.generated';
import { AuthService } from 'src/app/base/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PayTillNowSessionService {
  private sessionInfo: PayTillNowParkingSessionInfoDTO | null = null;
  constructor(private payTillNowClient: PayTillNowClient, private authService: AuthService) { }

  public loadPayTillNowParkingSessionInfo(sessionIdent: string): Observable<PayTillNowParkingSessionInfoDTO | null> {
    return this.payTillNowClient.getPayTillNowParkingSessionInfo(new PayTillNowSessionDTO({ sessionIdent }))
      .pipe(
        tap(info => this.sessionInfo = info)
      );
  }
}
